import {
  BackgroundColors,
  PositiveColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights, TypographyT4 } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const useStyles = createUseStyles(
  {
    fontsWrapper: {
      display: 'block',
      marginTop: Spacings.s16,
      overflow: 'hidden',
    },
    item: {
      borderRadius: CornerRadius.r16,
      padding: Spacings.s24,
      border: `2px solid ${BackgroundColors.tint2}`,
      marginBottom: Spacings.s8,
      '& a': {
        display: 'none',
      },
      '&:hover': {
        background:
          'linear-gradient(0deg, rgba(231, 220, 249, 0.50) 0%, rgba(231, 220, 249, 0.50) 100%), rgba(255, 255, 255, 0.20)',
        '& a': {
          display: 'flex',
        },
      },
      '@media screen and (max-width: 768px)': {
        padding: [Spacings.s24, Spacings.s12],
      },
    },
    buttonStyle: {
      '@media screen and (max-width: 768px)': {
        height: 32,
        fontSize: FontSizes.s14,
      },
    },
    itemHeader: {
      fontSize: FontSizes.s30,
      lineHeight: LineHeights.l36,
      color: PositiveColors.text.default,
    },
    itemHeaderWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 48,
    },
    imageframe: {
      background: 'transparent',
      width: 'inherit',
      height: 56,
      '@media screen and (max-width: 768px)': {
        maxWidth: 178,
      },
    },
    itemFooterInfo: {
      fontSize: TypographyT4,
      marginTop: Spacings.s12,
      color: TextColors.tint2,
      display: 'flex',
      gap: Spacings.s16,
      alignItems: 'center',
      fontWeight: FontWeights.semibold,
      marginBottom: Spacings.s4,
      '& > svg': {
        fill: '#2F2F2F',
      },
      '@media screen and (max-width: 768px)': {
        gap: Spacings.s12,
      },
    },
    horizontalLine: {
      paddingLeft: Spacings.s16,
      '@media screen and (max-width: 768px)': {
        paddingLeft: Spacings.s12,
      },
    },
    loadMore: {
      textAlign: 'center',
      maxWidth: 180,
      margin: [Spacings.s24, 'auto'],
    },
  },
  {
    name: 'Fonts-list',
  },
);

export default useStyles;
